import { realmSelectionManager } from '@inpart-io/devtools';
import { type IUserTenantAccess, queryBuilder } from '@inpart-io/devtools-iap';
import { RECEIVE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { userTenantAccessesManager } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

export const RETRIEVE_USER_TENANT_ACCESS_FROM_USER = 'retrieveUserTenantAccessFromUser';

export const actions: ActionTree<IUserTenantAccess, unknown> = {
    async [RETRIEVE_USER_TENANT_ACCESS_FROM_USER](context, { userIdList, properties }: { userIdList: number[]; properties?: string }): Promise<number[]> {
        const targetRealm = (await realmSelectionManager.calculateRealm())?.realm;

        const query = queryBuilder.build(queryBuilder.op.and(queryBuilder.cmp.isIn('user', userIdList), queryBuilder.cmp.equalTo('tenantName', targetRealm)));
        const userTenantAccesses = await userTenantAccessesManager.search(query, { properties });
        context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: userTenantAccesses });

        return userTenantAccesses.map((dataObject) => {
            return dataObject.dobjId;
        });
    }
};
